export class DistanceInfo{
    public displayDistance: boolean;
    public city: string;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/distance-info.model.ts